export const getLocalApplicationMetadata = () => {
    const appRoot = document.getElementById("root")!;

    const environment = appRoot.attributes.getNamedItem("app_env")?.value;

    const version = appRoot.attributes.getNamedItem("app_version")?.value;

    return { environment, version };
}